module.exports = __webpack_public_path__ + "static/media/advantage-5.46cf90c7.png";